import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import IntegrationErrorsStore from "./IntegrationErrorsStore";

const integrationErrorsRoute: RouteType = {
  name: "Integration Errors",
  path: "/admin/integration-errors",
  layout: "/admin",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "Integration Errors",
      enableRefreshButton: true,
      color: "primary",
      component: () => import("./IntegrationErrors.Header"),
    },
    body: {
      component: () => import("./IntegrationErrors.Body"),
      grayBackground: false,
    },
  },
  group: "Admin",
  searchAliases: ["failures", "sync errors", "webhook errors"],
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
  onEnter: ({ rootStore }) => {
    const store = rootStore.integrationErrorsViewStore as IntegrationErrorsStore;
    void store?.load();
  },
  dialogs: [
    {
      name: "IntegrationErrorDetailDialog",
      title: "Integration Error",
      component: () => import("./dialogs/IntegrationErrorDetail.Body"),
      closeButton: true,
      maxWidth: "md",
      fullWidth: true,
      height: 640,
      onClose: ({ rootStore }: { rootStore: RootStore }) => {
        const store = rootStore.integrationErrorsViewStore as IntegrationErrorsStore;
        store?.clearSelection();
      },
    },
  ],
};

export default integrationErrorsRoute;
